import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClient } from './_services/http.client';
import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalStorageModule } from 'angular-2-local-storage';
import { ToastyModule } from 'ng2-toasty';
import { LaddaModule } from 'angular2-ladda';

import { AppComponent } from './app.component';
import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { TabsModule } from 'ng2-bootstrap/tabs';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';

// Routing Module
import { AppRoutingModule } from './app.routing';
import { AgmCoreModule } from 'angular2-google-maps/core';
//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';

import {AuthGuard} from './_guards/auth.guard';
import {AuthService} from './_services/auth.service';
import {UserService} from './_services/user.service';
import {SessionService} from './_services/session.service';
import {Secured} from './_directives/secured.directive';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    AppRoutingModule,
    DropdownModule.forRoot(),
    TabsModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    ToastyModule.forRoot(),
    LocalStorageModule.withConfig({
        prefix: 'softmart-crm',
        storageType: 'localStorage'
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCroQTKAPe6yMpOghVZql8E-zkZTsqNTzc'
    }),
    LaddaModule
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    SimpleLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    Secured
  ],
  providers: [
    AuthGuard,
    AuthService,
    UserService,
    SessionService,
    HttpClient,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    { provide: LOCALE_ID, useValue: "es-MX" }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts